import React, { Component } from "react";
import "./style.css";

class Navigation extends Component {
  constructor() {
    super();
    this.state = {
      activeIndex: 0
    };
  }

  menuItems = [
    { label: "Weekly", value: 0 },
    { label: "Monthly", value: 1 },
    { label: "Yearly", value: 2 }
  ];

  componentWillReceiveProps(newProps) {
    this.setState({
      ...this.state,
      activeIndex: newProps.selected
    });
  }

  render() {
    this.menu = this.menuItems.map((currentVal, index, arr) => {
      let classes = "";
      classes +=
        this.state.activeIndex === index
          ? "div_analyticsNavigationItem div_analyticsNavigationItem_selected "
          : "div_analyticsNavigationItem ";

      classes += index === 0 ? "div_analyticsNavigationItem_first" : "";

      classes +=
        index + 1 === arr.length ? "div_analyticsNavigationItem_last" : "";

      return (
        <div
          key={index}
          style={style.navigationItem}
          className={classes}
          onClick={() => {
            this.props.action(currentVal.value);
          }}
        >
          <a style={style.anchor}>
            <p style={style.linkText}>{currentVal.label}</p>
          </a>
        </div>
      );
    });
    return <div style={style.wrapper}>{this.menu}</div>;
  }
}

export default Navigation;

const style = {
  wrapper: {
    display: "flex",
    justifyContent: "center"
  },
  navigationItem: {
    display: "flex",
    flexWrap: "nowrap",
    padding: "0px 30px 0px 30px",
    borderBottom: "1px solid #ccc",
    cursor: "pointer"
  },
  anchor: {
    textDecoration: "none"
  },
  linkText: {
    color: "#444445",
    fontSize: "20px",
    margin: "0px",
    marginTop: "25px",
    marginBottom: "10px"
  }
};
